// extracted by mini-css-extract-plugin
module.exports = {"phoneUSGif":"AnimatedPhone__phoneUSGif___2OI-D","phoneGifComp":"AnimatedPhone__phoneGifComp___5ZRzX","gif":"AnimatedPhone__gif___3DpbT"};